import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './HamburgerMenu.css';

function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, isAdmin, logout } = useAuth();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleLogout = () => {
    logout();
    closeMenu();
  };

  return (
    <div className={`hamburger-menu ${isOpen ? 'menu-open' : ''}`}>
      <button
        className="hamburger-button"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {isOpen && (
        <div className="menu-overlay" onClick={closeMenu}></div>
      )}

      <nav className={`menu-drawer ${isOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <h2>Menu</h2>
          <button className="close-button" onClick={closeMenu} aria-label="Close menu">
            ×
          </button>
        </div>

        <ul className="menu-list">
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          {isAuthenticated() && (
            <li>
              <Link to="/dashboard" onClick={closeMenu}>
                Dashboard
              </Link>
            </li>
          )}
          {isAuthenticated() && (
            <li>
              <Link to="/account" onClick={closeMenu}>
                Account
              </Link>
            </li>
          )}
          {isAdmin() && (
            <li>
              <Link to="/admin" onClick={closeMenu}>
                Admin
              </Link>
            </li>
          )}
          <li>
            <span className="menu-item-disabled">Courses</span>
          </li>
          {isAuthenticated() ? (
            <li>
              <button className="logout-button" onClick={handleLogout}>
                Logout
              </button>
            </li>
          ) : (
            <li>
              <Link to="/login" onClick={closeMenu} className="login-link-menu">
                Login
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
}

export default HamburgerMenu;
